import React from "react";
import "./TechnologyStackPage.scss";

// Assets
import ImageTechnologyStackBanner from "assets/images/banners/technology-stack-banner.png";

// Components
import LandingBanner from "components/LandingBanner/LandingBanner";
import Footer from "components/Footer/Footer";

// Utils
import useContentfulData from "lib/Contentful/hooks/useContentfulData";
import TechnologyStack from "components/TechnologyStack/TechnologyStack";

function TechnologyStackPage() {
  // State
  const contentfulData = useContentfulData("technology", "Technology Stack");

  return (
    <div className="technologyStackPage">
      <div className="technologyStackPage__banner">
        <LandingBanner
          title={"Technology Stack"}
          banner={ImageTechnologyStackBanner}
        />
      </div>
      <div className="technologyStackPage__content">
        <TechnologyStack technologyData={contentfulData.data} />
      </div>
      <div className="technologyStackPage__footer">
        <Footer />
      </div>
    </div>
  );
}

export default TechnologyStackPage;
